import _ from 'lodash';
import { createLexicalCTAEditor, createLexicalTextEditor } from 'modules/Lexical/editors';
import { getFontNames } from 'modules/Lexical/editorUtils';
import { DefaultCustomStyle, Layer } from 'const';
import {
  CombinedLayouts,
  CombinedDocuments,
  LayeredCombinedLayouts,
  LayeredRelations,
  OnlineBrandDefinition,
} from 'models';
import { isCallToAction, isTextComponent } from 'utils/entityType';
import { isObjectLayered } from 'utils/layers';
import { isRegularRelation } from 'utils/relations/isRegularRelation';

export function getUsingLayoutFontsNotExistsInProject(
  relations: LayeredRelations,
  documents: CombinedDocuments,
  projectBrandDefinition: OnlineBrandDefinition,
  layouts: CombinedLayouts | LayeredCombinedLayouts,
  documentIds: string[],
  layer: Layer,
): string[] {
  // To stop show font difference dialog on each RL drop we check is that RL is using on artboard.
  if (_.some(layouts, (layout => documentIds.includes(isObjectLayered(layout) ? layout.documentId[layer] : layout.documentId)))) {
    return [];
  }

  const projectFontNames = _(projectBrandDefinition.fonts).map(font => font.name).uniq().value();
  projectFontNames.push(DefaultCustomStyle.FONT_FAMILY);

  const layoutFontNames = new Set<string>();
  _.forEach(relations, (rel) => {
    if (!isRegularRelation(rel)) {
      return;
    }

    if (isTextComponent(rel)) {
      const documentId = rel.documentId[layer] || rel.documentId[Layer.ORIGINAL];
      if (documentId) {
        const document = documents[documentId];
        if (isTextComponent(document)) {
          const lexicalState = document.lexicalState;
          if (lexicalState) {
            const lexicalEditor = createLexicalTextEditor(lexicalState);
            const fontNames = getFontNames(lexicalEditor);

            fontNames.forEach(fontName => layoutFontNames.add(fontName));
          }
        }
      }
    }

    if (isCallToAction(rel)) {
      const documentId = rel.documentId[layer] || rel.documentId[Layer.ORIGINAL];
      if (documentId) {
        const document = documents[documentId];

        if (isCallToAction(document)) {
          const lexicalState = document.lexicalState;

          if (lexicalState) {
            const lexicalEditor = createLexicalCTAEditor(lexicalState);
            const fontNames = getFontNames(lexicalEditor);

            fontNames.forEach(fontName => layoutFontNames.add(fontName));
          }
        }
      }
    }
  });

  return _.difference(Array.from(layoutFontNames), projectFontNames);
}
